import PropTypes from "prop-types";
import ResourcesUtil from "@chemaxon/terminus-client/ui/utils/ResourcesUtil";
import MiniCard from "@chemaxon/terminus-client/ui/components/card/MiniCard";

function ResourceCard(props) {
  return (
    <MiniCard
      href={props.entryPointUrl}
      avatarSrc={ResourcesUtil.getAvatarPath(props.resourceType)}
      title={ResourcesUtil.getDisplayName(props.resourceType)}
    />
  );
}

ResourceCard.propTypes = {
  resourceType: PropTypes.string,
  entryPointUrl: PropTypes.string,
};

export default ResourceCard;
